<template>
    <div class="floor-left-item" @click="handleCargoClick" v-loading="loading">
        <div class="floor-left-img-wrap">
            <div class="item_image">
                <el-image fit="cover" :src="$img(cargo.sku_image, { size: 'mid' })"
                    @error="cargo.sku_image = defaultGoodsImage" />
            </div>
        </div>
        <div class="floor-left-title">{{ cargo.sku_name }}</div>
		<div class="floor-left-price"> <span>￥</span>{{ cargo.price }}</div>
        <div class="floor-left-sub-title">{{ cargo.introduction }}</div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    import { goodsSkuDetail } from "@/api/goods/goods"

    export default {
        name: "cargo_item",
        props: {
            cargo: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: false
            }
        },
        created() {
            this.$store.dispatch("site/defaultFiles")
        },
        computed: {
            ...mapGetters(["defaultGoodsImage"])
        },
        methods: {
            handleCargoClick() {
                if (this.cargo && this.cargo.sku_id) {
                    this.$router.pushToTab(`/sku-${this.cargo.sku_id}`)
                }
            }
        },
        watch: {}
    }
</script>

<style lang="scss" scoped>
    .floor-left-item {
        // width: 20.3%;
		width: 234px;
        // height: 50%;
		height: 330px;
        box-sizing: border-box;
        background-color: #ffffff;
        padding: 12px 10px;
        // border: 1px solid #e9e9e9;
        border-top: none;
        border-left: none;
        cursor: pointer;
        margin-bottom: 10px;
		
        &:nth-child(-n + 3) {
            // border-top: 1px solid #e9e9e9;
        }

        &:nth-child(3n + 1) {
            // border-left: 1px solid #e9e9e9;
        }

        .floor-left-title {
            width: 100%;
            font-size: $ns-font-size-base;
			overflow:hidden; 
			text-overflow:ellipsis;
			display:-webkit-box; 
			-webkit-box-orient:vertical;
			-webkit-line-clamp:2; 
            // white-space: nowrap;
			font-size: 14px;
            
        }
		.floor-left-price{
			
			span{
				font-size: 12px;
			}
			color: #FF6400;
			font-size: 18px;
			font-weight: 600;
		}
        .floor-left-sub-title {
            font-size: $ns-font-size-sm;
            color: $base-color;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .floor-left-img-wrap {
            width: 100%;
            // height: 177px;

            .item_image {
				display: flex;
				justify-content: center;
				align-items: center;
                height: 100%;
            }
        }
    }
	.floor-left-item:hover{
		transform: translateY(-2px);
		transition: transform linear .3s;
		box-shadow: 0 15px 30px rgb(0 0 0 / 10%);
		-moz-box-shadow:  0 15px 30px rgb(0 0 0 / 10%);
		-webkit-box-shadow:  0 15px 30px rgb(0 0 0 / 10%);
		-ms-box-shadow:  0 15px 30px rgb(0 0 0 / 10%);
	}
</style>